
import React from 'react';
import { Box, Meter, Stack, Text } from 'grommet';

import { percentToString } from '../../utils';

const TitleInfoText = ({title, value}) => {
    return (
        <Box direction="row">
            <Box align="start" flex="grow">
                <Text size="small">{title}:</Text>
            </Box>
            <Box align="end">
                <Text size="small" weight="bold">{value}</Text>
            </Box>
        </Box>
    );
}

const CircleMeter = (props) => {
    const getValues = (value) => {
        return [{
            color: 'accent-1',
            value: value
        }];
    }

    return (
        <Meter
            {...props}
            background={{ color: 'light-6', opacity: 'medium' }}
            type="circle"
            size={props.size}
            values={getValues(props.value)}
        />
    );
}

function getLabelTextSize(size) {
    switch (size) {
        case 'small':
        case 'medium':
        case 'large':
            return 'xxlarge';
        default:
            return 'medium';
    }
}

const ValueLabel = (props) => {
    return (
        <Text size={getLabelTextSize(props.size)} weight="bold">
            {percentToString(props.value)}
        </Text>
    )
}

const ValueInfo = ({infoTexts}) => {
    return (
        <Box>
            {infoTexts.map((item, index) => {
                return (
                    <TitleInfoText
                        key={index}
                        title={item.title}
                        value={item.value}
                    />
                );
            })}
        </Box>
    );
}

const ValueMeterTile = (props) => {
    return (
        <Box direction="column" background="light-2" gap="small" pad="small" margin="small" width="300px">
            <Box height="50px">
                <Text>{props.title}</Text>
            </Box>
            <Box align="center">
                <Stack anchor='center'>
                    <CircleMeter value={props.value} size="xsmall" thickness="small" />
                    <ValueLabel value={props.value} />
                </Stack>
            </Box>
            <ValueInfo infoTexts={props.infoTexts} />
        </Box>
    );
}

export default ValueMeterTile;
